import { Component, Input, OnDestroy } from '@angular/core';
import { startOfDay, parseISO, differenceInDays }from 'date-fns'


interface IPlanData{
  billingPeriod?: any;
  unitPrice?: number;
  unitsUsed?: number;
  units?: number;
  overagePrice?: number;
}

@Component({
  selector: 'summary-usage',
  templateUrl: './summary-usage.component.html',
  styleUrls: ['./summary-usage.component.scss'],
})
export class SummaryUsageComponent{
  @Input() type: string;
  @Input('usage') planData;
  public unitsRemaining:number = 0;
  public daysRemaining;
  public overage = false;

  ngOnInit(){
    this.setup();
  }

  ngOnChanges(changes){
    if(changes.planData.currentValue){
      this.planData = changes.planData.currentValue;
      this.setup();
    }
  }

  private setup(){
    this.overage = false;
    if(this.planData){
      let billingPeriod = this.planData.billingPeriod.split(' - ');
      let start = parseISO(billingPeriod[0]);
      let end  = parseISO(billingPeriod[1]);
      let daysRemaining = differenceInDays(end, startOfDay(new Date()));
      this.daysRemaining = daysRemaining > 0 ? daysRemaining : 0;

      if( this.planData.unitsUsed > this.planData.units ){
        this.unitsRemaining = this.planData.unitsUsed - this.planData.units;
        this.overage = true
      }else{
        this.unitsRemaining = this.planData.units - this.planData.unitsUsed;
      }
    }
  }


}

